import clsx from "clsx";
import { useLauncherStore } from "@/app/[tenantId]/[messengerId]/[hostConfig]/lib/client/contexts/LauncherStoreContext";
import { useShallow } from "zustand/react/shallow";

export const ChatContainer = ({ children }: { messengerId: string; children: React.ReactNode }) => {
  const { isOpen, isFullscreen } = useLauncherStore(
    useShallow((state) => ({
      isOpen: state.isOpen,
      isFullscreen: state.isFullscreen,
    })),
  );

  return (
    <div
      id="ChatContainer"
      className={clsx(
        "relative flex w-full grow flex-col",
        isFullscreen ? undefined : "rounded-b-2xl rounded-t-2xl [&>*:last-child]:rounded-b-2xl",
        // On opening and closing the chat, we animate the shadow in line with the open / close animation. It should be transparent when closed.
        "transition-shadow",
        isOpen ? "duration-300" : "duration-0",
        isOpen ? "shadow-[0_5px_30px_0_rgba(0,0,0,0.2)]" : "shadow-[0_5px_30px_0_rgba(0,0,0,0)]",
      )}
    >
      {children}
    </div>
  );
};
